import { defineComponent as _defineComponent } from 'vue'
import CcCard from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCard.ts.vue';
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcError from '@/views/Automation/CampaignCreatorV2/components/CcError/CcError.ts.vue';
import CcRadioGroupIcon from '@/views/Automation/CampaignCreatorV2/components/CcRadioGroup/CcRadioGroupIcon.ts.vue';
import { BuyingType, Objective } from '@/views/Automation/CampaignCreatorV2/helpers/facebook/Campaign';
import useCampaignStore from '@/views/Automation/CampaignCreatorV2/store/Campaign';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import Treeselect from '@riophae/vue-treeselect';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CampaignDetails.ts',
  setup(__props) {

const campaignStore = useCampaignStore();
const { getField } = storeToRefs(campaignStore);

const options = [
  { id: BuyingType.AUCTION, label: 'Auction' },
  { id: BuyingType.RESERVED, label: 'Reservation', isDisabled: true },
  { id: BuyingType.FIXED_CPM, label: 'Fixed Cpm', isDisabled: true },
];

const buyingType = computed(() => getField.value('buying_type')?.value?.[0] || {});
const objective = computed(() => getField.value('objective')?.value?.[0]);

function onBuyingTypeChange(value: { id: BuyingType }) {
  campaignStore.addOrEditVariable('buying_type', {
    field: 'buying_type',
    value: value.id,
    variableId: 'buying_type',
  });
}

function onObjectiveChange(value: Objective) {
  campaignStore.addOrEditVariable('objective', {
    field: 'objective',
    value,
    variableId: 'objective',
  });
}

return { __sfc: true,campaignStore, getField, options, buyingType, objective, onBuyingTypeChange, onObjectiveChange, CcCard, CcCardItem, CcError, CcRadioGroupIcon, CardLayer, Treeselect }
}

})